import React, { useState } from 'react';
import { Globe, Smartphone, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import HeroSection from './Home/HeroSection';
import ProductGrid from './Home/ProductGrid';
import ProductComparisonTable from './Home/ProductComparisonTable';
import BottomSections from './Home/BottomSections';
import HowItWorks from './HowItWorks';
import WhyChooseUs from './WhyChooseUs';
import TrustedByThousands from './TrustedByThousands';
import CTASection from './CTASection';
import FAQAndSecurity from './FAQAndSecurity';

export default function Homepage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <ProductGrid />
      <HowItWorks />
      <ProductComparisonTable />
      <WhyChooseUs />
      <TrustedByThousands />
      <CTASection />
      <FAQAndSecurity />
      {/* <BottomSections /> */}
    </div>
  );
}